export default "__VITE_ASSET__yJRa$0is__"